import { useEffect, useCallback } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import {
  fetchEnrollmentBillingAction,
} from "@/modules/eventRegistration/features/EventWaitlist/slices/eventTransactionsSlice";
import { UseEventTransactionsReturn } from "@/modules/eventRegistration/features/EventWaitlist/hooks/useEventTransactions/types";

interface UseEventTransactionsProps {
  eventUuid?: string;
}

export default function useEventTransactions({
  eventUuid,
}: UseEventTransactionsProps = {}): UseEventTransactionsReturn {
  const { toast } = useToast();
  const dispatch = useAppDispatch();

  const {
    loadingEnrollmentBilling,
    enrollmentBillingError,
    enrollmentBillingItems,
  } = useAppSelector((state) => state.eventTransactions);

  useEffect(() => {
    if (eventUuid) {
      dispatch(fetchEnrollmentBillingAction({ uuid: eventUuid }));
    }
  }, [dispatch, eventUuid]);

  useEffect(() => {
    if (enrollmentBillingError) {
      toast({
        title: "Error",
        description: enrollmentBillingError,
        variant: "destructive",
      });
    }
  }, [enrollmentBillingError, toast]);

  const refreshData = useCallback(async () => {
    if (eventUuid) {
      dispatch(fetchEnrollmentBillingAction({ uuid: eventUuid }));
    }
  }, [dispatch, eventUuid]);

  return {
    enrollmentBillingItems,
    isLoading: loadingEnrollmentBilling,
    isRefreshing: loadingEnrollmentBilling,
    isProcessing: false,
    refreshData,
  };
}
